import { apiUrl } from "../../../setting";

export const getGuestFeedbackUrl = () => {
    return `${apiUrl}/getGuestFeedback`;
};

export const deleteGuestFeedbackUrl = (_id) => {
    return `${apiUrl}/deleteGuestFeedback/${_id}`;
};
